export const FETCH_TALENT_ADVISOR = 'candidateExperience/views/statusInfo/FETCH_TALENT_ADVISOR'
export const FETCH_TALENT_ADVISOR_SUCCESS = 'candidateExperience/views/statusInfo/FETCH_TALENT_ADVISOR_SUCCESS'
export const FETCH_TALENT_ADVISOR_ERROR = 'candidateExperience/views/statusInfo/FETCH_TALENT_ADVISOR_ERROR'

export const FETCH_CODING_TEST = 'candidateExperience/views/statusInfo/FETCH_CODING_TEST'
export const FETCH_CODING_TEST_SUCCESS = 'candidateExperience/views/statusInfo/FETCH_CODING_TEST_SUCCESS'
export const FETCH_CODING_TEST_ERROR = 'candidateExperience/views/statusInfo/FETCH_CODING_TEST_ERROR'

export const fetchTalentAdvisor = id => ({
  type: FETCH_TALENT_ADVISOR,
  meta: { id },
  payload: {
    fetchingTalentAdvisor: true,
    fetchTalentAdvisorError: null,
  },
})

export const fetchTalentAdvisorSuccess = result => ({
  type: FETCH_TALENT_ADVISOR_SUCCESS,
  payload: {
    fetchingTalentAdvisor: false,
    lastUpdatedTalentAdvisor: Date.now(),
    talentAdvisor: result.id,
  },
})

export const fetchTalentAdvisorError = errorMessage => ({
  type: FETCH_TALENT_ADVISOR_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchCodingTest = id => ({
  type: FETCH_CODING_TEST,
  meta: { id },
  payload: {
    fetchingCodingTest: true,
    fetchCodingTestError: null,
  },
})

export const fetchCodingTestSuccess = result => ({
  type: FETCH_CODING_TEST_SUCCESS,
  payload: {
    fetchingCodingTest: false,
    lastUpdatedCodingTest: Date.now(),
    codingTest: result.id,
  },
})

export const fetchCodingTestError = errorMessage => ({
  type: FETCH_CODING_TEST_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

const defaultMap = {
  talentAdvisor: null,
  lastUpdatedTalentAdvisor: null,
  fetchingTalentAdvisor: false,
  fetchTalentAdvisorError: null,

  codingTest: null,
  lastUpdatedCodingTest: null,
  fetchingCodingTest: false,
  fetchCodingTestError: null,
}

const map = (state = defaultMap, { type, payload }) => {
  switch (type) {
    case FETCH_TALENT_ADVISOR:
    case FETCH_TALENT_ADVISOR_SUCCESS:
    case FETCH_CODING_TEST:
    case FETCH_CODING_TEST_SUCCESS:
      return { ...state, ...payload }

    case FETCH_TALENT_ADVISOR_ERROR:
      return {
        ...state,
        fetchingTalentAdvisor: false,
        fetchTalentAdvisorError: payload,
      }

    case FETCH_CODING_TEST_ERROR:
      return {
        ...state,
        fetchingCodingTest: false,
        fetchCodingTestError: payload,
      }

    default:
      return state
  }
}

export default map

export const getStatusInfoView = state => state.views.statusInfo || defaultMap
